// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const usePeriodsApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getPeriods = () => {
    return request("GET", `${API_STAGES_URL}/v1/periods`)
  }

  return [
    requestState,
    payload,
    error,
    {
      getPeriods,
    },
  ]
}

export default usePeriodsApi
